import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

@Injectable()
export class HistoryServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  private consimentInfo: any = null;

  constructor(public http: Http, public globalServiceProvider: GlobalServiceProvider, private transfer: FileTransfer) {
    console.log('Hello HistoryServiceProvider Provider');
  }

  get getConsignmentInfo(): any {
    return this.consimentInfo;
  }
  set setConsignmentInfo(valueObj: any) {
    this.consimentInfo = valueObj;
  }

  getConsignments(custCode, pageNo, siteAccount) {
    let uri = siteAccount? this.baseUrl + '/api/consignmentBySite/' + custCode + '/' + pageNo
    : this.baseUrl + '/api/consignment/' + custCode + '/' + pageNo

    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        return null;
      }
      );
  }

  searchConsignments(searchString, custCode, siteAccount, pageNo) {
    let uri = siteAccount? this.baseUrl + '/api/consignmentBySite/search/' + searchString + '/' + custCode + '/' + pageNo
      : this.baseUrl + '/api/consignment/search/' + searchString + '/' + custCode + '/' + pageNo;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        return null;
      }
      );
  }


  searchConsignmentsByDate(fromDate, toDate, custCode, siteAccount, pageNo) {
    let uri = siteAccount? this.baseUrl + '/api/consignmentBySite/search/' + fromDate + '/' + toDate + '/' + custCode + '/' + pageNo
      :this.baseUrl + '/api/v3/consignment/searchbydate/' + fromDate + '/' + toDate + '/' + custCode + '/' + pageNo;

    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        return null;
      }
      );
  }

  exportConsignment(fromDate, toDate, custCode, siteAccount) {
    let uri = this.baseUrl + '/api/consignment/export/' + fromDate + '/' + toDate + '/' + custCode + '/' + siteAccount;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          return null;
        }
      );
  }

  getPODs(jobId) {
    let uri = this.baseUrl + '/api/jobs/podsv2/' + jobId;  
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        return null;
      }
      );
  }

  getPODFiles(data: any) {
    let options = new RequestOptions({
      method: 'GET',
      responseType: ResponseContentType.ArrayBuffer,
      headers: new Headers({ 'content-type': 'application/json' }),
    })
    let uri = this.baseUrl + '/api/download/podsv3';
    return this.http
      .post(uri, data, options)
      .toPromise()
      .then(data => {
        return data.arrayBuffer();
      })
      .catch(
      err => {
        return null;
      }
      );
  }

  downloadPODFiles(pathFile, targetPath, filename) {

    let promise = new Promise((resolve, reject) => {
      let url = this.baseUrl + '/api/download/pods/' + pathFile;
      let token = localStorage.getItem('tokenBTCustomerAPI');
      let options = {
          headers: {
              "Authorization": "Bearer " + token
          }
      };
      url = encodeURI(url);
      const fileTransfer: FileTransferObject = this.transfer.create();
      if (fileTransfer) {
        fileTransfer.download(url, targetPath + filename, false, options).then((entry) => {
          console.log('download complete: ' + entry.toURL());
          resolve(entry.toURL());
        }, (error) => {
          console.log('error: ', error);
          reject(null);
        });
      } else {
        reject(null);
      }
    })
    return promise;
  }

  getJobLinesById(id) {
    let uri = this.baseUrl +'/api/v2/jobs/tankerproduct/' + id;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getPricing(jobId) {
    let uri = this.baseUrl + '/api/jobs/pricing/' + jobId;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        return null;
      }
      );
  }

  getInvoice(jobId) {
    let uri = this.baseUrl + '/api/invoice/' + jobId;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        console.log('err get Invoice: ', err);
        return null;
      }
      );
  }

  downloadInvoice(invoiceId) {
    let options = new RequestOptions({
      method: 'GET',
      responseType: ResponseContentType.ArrayBuffer,
      headers: new Headers({ 'content-type': 'application/json' }),
    })
    let uri = this.baseUrl + '/api/invoice/download/' + invoiceId;
    return this.http
      .get(uri, options)
      .toPromise()
      .then(data => {
        return data.arrayBuffer();
      })
      .catch(
      err => {
        console.log('err download Invoice: ', err);
        return null;
      }
      );
  }

  getLegs(jobId) {
    let uri = this.baseUrl + '/api/jobs/legs/' + jobId;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
      err => {
        console.log('err get Invoice: ', err);
        return null;
      }
      );
  }

  consignmentHistory(jobNo: string, fromDate: string, toDate: string, custCode: string, siteAccount: boolean, pageNo: number, isIxom: boolean) {
      return new Promise<Array<any>>((resolve: any, reject: any) => {      
        let uri = this.baseUrl + '/api/consignment/history';       
        if (isIxom === true) {
          uri = this.baseUrl + '/api/ixom/consignment/history';
        }
        let result = null;
        const params = {             
          jobNo: jobNo,
          custCode: custCode,
          fromDate: fromDate,
          toDate: toDate,
          siteAccount: siteAccount,
          pageNo: pageNo
        };
        console.log('params: ', params)
        return this.http
          .get(uri, { params: {filter: params} })
          .toPromise()
          .then(data => {
            result = data.json();
            resolve(result);
          })
          .catch(          
            err => {
              resolve([]);
            }
          )
      });
  }

  exportConsignmentV2(jobNo: string, fromDate: string, toDate: string, custCode: string, siteAccount: boolean, isIxom: boolean) {
    let uri = this.baseUrl + '/api/consignmentv2/export';
    if (isIxom === true) {
      uri = this.baseUrl + '/api/ixom/consignment/export';
    }
    let result = null;
    const params = {             
      jobNo: jobNo,
      custCode: custCode,
      fromDate: fromDate,
      toDate: toDate,
      siteAccount: siteAccount
    };
    return this.http
    .get(uri, { params: {filter: params} })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          return null;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/providers/history-service/history-service.ts